module.exports = __webpack_public_path__ + "static/media/multi-unit-count.d7983ac1.svg";